import React, { useState, useEffect } from "react";
import "./Contact_Us.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMapLocationDot,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Success_Modal from "../success-modal/Success_Modal";
import { useNavigate } from "react-router-dom";
import Common_Banner from "../common/common-banner/Common_Banner";
import { useForm, Controller } from "react-hook-form";

import { useDispatch, useSelector } from "react-redux";
import {
  AllBranches,
  AllSocialLinks,
  AllAppSetup,
} from "../../features/admin/common/Slice";
import { IDS } from "../../utils/IDS";

import {
  CreateContact_Us,
  resetContactState,
} from "../../features/admin/contactus/contact/Slice";

const Contact_Us = ({ show, handleClose = () => { } }) => {
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const branches = useSelector((state) => state?.common?.all_branches);
  const appsetup = useSelector((state) => state?.common?.all_app_setup);
  const social_links = useSelector((state) => state?.common?.all_social_links);

  useEffect(() => {
    dispatch(AllBranches());
    dispatch(AllSocialLinks());
    dispatch(AllAppSetup());
  }, [dispatch]);

  // // const handleSubmit = (e) => {
  // //   e.preventDefault();
  // //   setShowModal(true); // open success modal

  //   setTimeout(() => {
  //     setShowModal(false);
  //     navigate("/");
  //   }, 3000);
  // };

  // const handleClose = () => {
  //   setShowModal(false);
  //   navigate("/");
  // };

  const onSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      const res = await dispatch(CreateContact_Us(data)).unwrap();

      if (res?.success) {
        setShowModal(true);
        reset();

        setTimeout(() => {
          setShowModal(false);
          handleClose();
        }, 2000);
      }
    } catch (error) {
      console.log("Contact error:", error);
    }
  };

  const closeSuccessModal = () => {
    setShowModal(false);
    handleClose();
    reset();
  };

  useEffect(() => {
    if (!show) {
      reset();
    }
  }, [show, reset]);

  return (
    <section className="Contact_Us">
      <Common_Banner title="Contact Us" />
      <div className="container">
        <div className="contact_section">
          <div className="row justify-content-center">
            <div className="col-lg-5 order-lg-1 order-md-2 order-sm-2 order-2">
              <div className="contact_left">
                {/* Sambhajinagar */}
                {/* <div className="location_box">
                  <div className="location_info">
                    <h5>
                      <span>
                        <FontAwesomeIcon
                          icon={faMapLocationDot}
                          style={{ color: "rgb(255, 212, 59)" }}
                        />
                      </span>{" "}
                      Sambhajinagar
                    </h5>

                    <p>
                      C-Wing First Floor, Prozone Mall, API Corner, MIDC
                      Industrial Area, Chilkalthana, Chhatrapati Sambhajinagar,
                      Maharashtra 431006
                    </p>
                  </div>

                  <div className="map_box">
                    <iframe
                      title="sambhajinagar-map"
                      src="https://www.google.com/maps?q=Prozone+Mall+Aurangabad&output=embed"
                      width="100%"
                      height="120"
                      style={{ border: 0 }}
                      loading="lazy"
                    ></iframe>
                  </div>
                </div> */}

                {/* Nagpur */}
                {/* <div className="location_box">
                  <div className="location_info">
                    <h5>
                      {" "}
                      <span>
                        <FontAwesomeIcon
                          icon={faMapLocationDot}
                          style={{ color: "rgb(255, 212, 59)" }}
                        />
                      </span>{" "}
                      Nagpur
                    </h5>

                    <p>
                      C-Wing First Floor, Prozone Mall, API Corner, MIDC
                      Industrial Area, Chilkalthana, Chhatrapati Sambhajinagar,
                      Maharashtra 431006
                    </p>
                  </div>

                  <div className="map_box">
                    <iframe
                      title="nagpur-map"
                      src="https://www.google.com/maps?q=Prozone+Mall+Aurangabad&output=embed"
                      width="100%"
                      height="120"
                      style={{ border: 0 }}
                      loading="lazy"
                    ></iframe>
                  </div>
                </div> */}

                {branches?.map((branch) => (
                  <div className="location_box" key={branch.id}>
                    <div className="location_info">
                      <h5>
                        <span>
                          <FontAwesomeIcon
                            icon={faMapLocationDot}
                            style={{ color: "rgb(255, 212, 59)" }}
                          />
                        </span>{" "}
                        {branch.name}
                      </h5>
                      <p>{branch.address}</p>
                      <p>
                        {branch.city?.name}, {branch.state?.name}
                      </p>
                      <p><FontAwesomeIcon
                      icon={faPhone}
                      style={{ color: "#093d5d" }}
                      className="contact_icon"
                    />&nbsp;{branch.mobile_no}</p>
                    </div>

                    {branch.address && (
                      <div className="map_box">
                        <iframe
                          title={`${branch.name}-map`}
                          src={`https://www.google.com/maps?q=${encodeURIComponent(
                            branch.address,
                          )}&output=embed`}
                          width="100%"
                          height="120"
                          style={{ border: 0 }}
                          loading="lazy"
                        ></iframe>
                      </div>
                    )}
                  </div>
                ))}

                {/* Email */}
                <div className="contact_detail">
                  <div className="contact_holder">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      style={{ color: "#ffffff" }}
                      className="contact_icon"
                    />
                    <span className="contact">Email Address</span>
                  </div>

                  <p className="detail">{appsetup?.email}</p>
                </div>

                {/* <div className="contact_detail">
                  <div className="contact_holder">
                    <FontAwesomeIcon
                      icon={faPhone}
                      style={{ color: "#ffffff" }}
                      className="contact_icon"
                    />

                    <span className="contact">Phone Number</span>
                  </div>

                  <p className="detail">{appsetup?.mobile_no}</p>
                </div> */}


                
              </div>
            </div>

            {/* RIGHT SIDE FORM */}

            <div className="col-lg-5 order-lg-2 order-sm-1 order-md-1 mb-4">
              <div className="contact_form">
                <h4 className="send_msg">
                  Send Us a <span>Message</span>
                </h4>

                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Form.Group className="mb-3">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter your full name"
                      {...register("name", {
                        required: "Name is required",
                        minLength: {
                          value: 3,
                          message: "Name must be at least 3 characters",
                        },
                        maxLength: {
                          value: 50,
                          message: "Name cannot exceed 50 characters",
                        },
                        pattern: {
                          value: /^[A-Za-z]+(\s[A-Za-z]+)*$/,
                          message:
                            "Name should contain only letters and single spaces",
                        },
                      })}
                      onChange={(e) => {
                        const value = e.target.value.replace(
                          /[^A-Za-z\s]/g,
                          "",
                        );
                        e.target.value = value;

                        register("name").onChange(e);
                      }}
                    />
                    {errors.name && (
                      <small className="text-danger">
                        {errors.name.message}
                      </small>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="Enter your mail id"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(?:[A-Za-z]{2,})$/,
                          message: "Enter a valid email address",
                        },
                      })}
                    />
                    {errors.email && (
                      <small className="text-danger">
                        {errors.email.message}
                      </small>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Contact Number</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter your number"
                      maxLength={10}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                      {...register("mobile_number", {
                        required: "Mobile number is required",
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: "Mobile number must be exactly 10 digits",
                        },
                      })}
                    />
                    {errors.mobile_number && (
                      <small className="text-danger">
                        {errors.mobile_number.message}
                      </small>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      maxLength={200}
                      placeholder="Enter your message"
                      {...register("message", {
                        required: "Message is required",
                        minLength: {
                          value: 10,
                          message: "Message must be at least 10 characters",
                        },
                        maxLength: {
                          value: 200,
                          message: "Message cannot exceed 200 characters",
                        },
                      })}
                    />
                    {errors.message && (
                      <small className="text-danger">
                        {errors.message.message}
                      </small>
                    )}
                  </Form.Group>

                  <div className="form_bottom">
                    {/* <div className="social_icons">
                      {[
                        {
                          label: "/assets/images/home/footer/icon-1.png",
                          link: "https://www.facebook.com",
                        },
                        {
                          label: "/assets/images/home/footer/icon-2.png",
                          link: "https://www.instagram.com",
                        },
                        {
                          label: "/assets/images/home/footer/icon-3.png",
                          link: "https://www.youtube.com",
                        },
                        {
                          label: "/assets/images/home/footer/icon-4.png",
                          link: "https://www.twitter.com/",
                        },
                      ].map((item, index) => (
                        <a
                          key={index}
                          href={item.link}
                          className="footer_link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={item.label}
                            alt=""
                            className="footer_icon"
                          />
                        </a>
                      ))}
                    </div> */}

                    <div className="social_icons">
                      {social_links?.map((item) => (
                        <a
                          key={item.id}
                          href={item.url}
                          className="footer_link"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={`${IDS.IMG_URL}${item.icon}`}
                            alt={item.name}
                            className="footer_icon"
                          />
                        </a>
                      ))}
                    </div>

                    <button className="submit_btn" type="submit">
                      {" "}
                      Submit Now
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Success_Modal
        text_msg="Form Successfull"
        show={showModal}
        handleClose={closeSuccessModal}
      />
    </section>
  );
};

export default Contact_Us;
